import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo, socialLinks, contactInfo } from '../data/mock';
import { Linkedin, MapPin, Mail, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerNav = [
    { name: 'About', href: '/about' },
    { name: 'Multi-Ion™ Technology', href: '/multi-ion-technology' },
    { name: 'Products', href: '/products' },
    { name: 'Safety', href: '/safety' },
    { name: 'Media', href: '/media' },
    { name: 'Careers', href: '/careers' },
  ];

  const legalLinks = [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Legal', href: '/legal' },
  ];

  return (
    <footer className="relative bg-gray-950 border-t border-white/5" data-testid="footer">
      {/* Gradient accent */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-emerald-500/50 to-transparent" />
      
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/">
              <img
                src={companyInfo.logo}
                alt={companyInfo.name}
                className="h-12 w-auto mb-4"
              />
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed mb-4 max-w-sm">
              Building the future of energy storage with Multi-Ion technology.
            </p>
            
            {/* Social Links */}
            <div className="flex gap-3">
              <a
                href={socialLinks.twitter}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-emerald-500 hover:border-emerald-500 transition-all group"
              >
                <svg className="w-4 h-4 text-gray-500 group-hover:text-white" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a
                href={socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center hover:bg-emerald-500 hover:border-emerald-500 transition-all group"
              >
                <Linkedin className="w-4 h-4 text-gray-500 group-hover:text-white" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {footerNav.map((item) => (
                <li key={item.name}>
                  <Link 
                    to={item.href} 
                    className="text-gray-400 hover:text-emerald-400 text-sm transition-colors"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact</h3>
            <div className="space-y-3">
              <a href={`mailto:${contactInfo.email}`} className="flex items-center gap-2 text-gray-400 hover:text-emerald-400 text-sm transition-colors">
                <Mail className="w-4 h-4 shrink-0" />
                {contactInfo.email}
              </a>
              <a href={`tel:${contactInfo.phone}`} className="flex items-center gap-2 text-gray-400 hover:text-emerald-400 text-sm transition-colors">
                <Phone className="w-4 h-4 shrink-0" />
                {contactInfo.phone}
              </a>
              <div className="flex items-start gap-2 text-gray-400 text-sm">
                <MapPin className="w-4 h-4 shrink-0 mt-0.5" />
                <span>{contactInfo.address}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} Gegadyne Energy Pvt. Ltd. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            {legalLinks.map((item) => (
              <a
                key={item.name}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-emerald-400 text-sm transition-colors"
              >
                {item.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
